module.exports = __webpack_public_path__ + "files/2845d6249fda2cb959be55ca21f188e6.png";